export default __webpack_public_path__ + "static/media/advantageBgDec1.3191866f.png";